import { constants } from "../../misc/constants";
import Scenario1 from "./Scenario1";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario1Part4 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-1-1',
        chapterCinematic36: 'medsurg-cinematic-1-36',
        chapterCinematic37: 'medsurg-cinematic-1-37',
        chapterCinematic38: 'medsurg-cinematic-1-38',
        chapterCinematic39: 'medsurg-cinematic-1-39',
        chapterCinematic40: 'medsurg-cinematic-1-40',
		chapterCinematic41: 'medsurg-cinematic-1-41',
	}

	constructor(scenario: Scenario1, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Talk4: boolean = false;
	private Action1: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;

	public get partId(): string {
		return constants.scenarios.scenario1.parts.level1Part4.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario1/video1' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario1/video10.mp4'];
	}

	public start() {
		const context = this;
		this.RememberDisplayed = false;

		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
			title: 'Vitals - On Admission'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
			list: '<li>Temperature: 98.6</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
			list: '<li>Pulse: 70</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
			list: '<li>Respirations: 20</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
			list: '<li>Blood Pressure: 130/80</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
			list: '<li>Oxygen Saturation: 92% room air</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
			title: 'Vitals - 11:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
			visit: context.scenario.visit1,
			lineBreak: true,
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowBasicID, {
			title: 'Patient Information',
			description: '<ul style=\"list-style-type:square\"><li>Joe Fellow, a 34-year-old male, Caucasian patient, has been admitted to the medical surgical unit for intravenous (IV) antibiotic therapy after having been diagnosed with pneumonia. </li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowBasicID, {
			title: 'Patient History',
			description: '<ul style=\"list-style-type:square\"><li>Patient reports nagging headache and general weakness as an active problem</li><li>Pneumonia</li><li>No allergies</li><li>Morse Fall Score: 30</li><li>Caucasian</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowBasicID, {
			title: 'Active Medications',
			description: '<ul style=\"list-style-type:square\"><li>Levofloxacin</li><li>Acetaminophen</li><li>Dextromethorphan</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowBasicID, {
			title: 'Providers Orders',
			description: '<ul style=\"list-style-type:square\"><li>IV antibiotic therapy for pneumonia</li><li>Continuous infusion of normal saline at 125 ml/hr</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowBasicID, {
			title: 'Dietary Restrictions',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowBasicID, {
			title: 'Other Observations',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowBasicID, {
			title: 'Post-Op Information',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});

		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
		this.scenario.displayModalPop(
			null,
            'Skipping to part 5',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
		context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            'You have a new patient to visit in room 2',
            () => {
                this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic36, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '4', '1', false, false);
				context.TalkCount = 4;
				context.ActionCount = 1;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.displayDebrief(950, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
			visit: context.scenario.visit2,
			lineBreak: true,
		});
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.PatientRecordUI, {
            top: [
				{
					description: 'Name: Joe Fellow'
				},
				{
					description: 'Room: #2'
				},
				{
					description: 'Age: 34'
				},
				{
					description: 'Sex: Male'
				}
			],
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).fellowBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).fellowNursesID),
			lab: [
				{
					title: 'Test Name'
				},
				{
					title: 'Results'
				},
				{
					title: 'Normal Range'
				}
			],
			vitals: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).fellowVitalsID),
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		});

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario1).PrFellowID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'Can you describe your pain?',
					onClicked: () => {
						this.segment1TalkPain();
					},
					disable: () => this.Talk3
				},
				{
					toppx: '350px',
					titletext: 'Would you like something for the pain?',
					onClicked: () => {
						this.segment1TalkForPain();
					},
					disable: () => this.Talk4
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "Horrible. Everything hurts, but especially my head and chest.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 50,
					talktext1: 'Pain Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Headache',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: "Nausea",
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Trembling',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Sweating',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 5,
					prequizheight: 4,
					quiztop: '410px',
					maxPoints: 100,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'General',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Surgical Site',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Abdominal',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Head',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Chest',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic38, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic36, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 5,
			extBottom: true,
			extText: "I'd say my pain is at a 5.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic39, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic36, () => {}, true);
		});
	}

	private segment1TalkPain() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Can you describe your pain?',
			isTalks: true,
			extBottom: true,
			extText: "Since yesterday, I've had a sharp, stabbing pain in my chest when I cough or breathe in deeply.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 100,
					talktext1: 'Pain Assessment',
					talktext2: 'Pain Description',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Stabbing',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Sharp',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Burning',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Aching',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Throbbing',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Persistent',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: "Intermittent",
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic40, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic36, () => {}, true);
		});
	}

	private segment1TalkForPain() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Would you like something for the pain?',
			isTalks: true,
			extBottom: true,
			extText: "Yes, please.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
					title: context.scenario.medicineAdministered,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.medicineAdministered)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk4 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 100,
					binaryq: true,
					talktext1: 'Medication Administered',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic41, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic36, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '99.0',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
					list: '<li>Temperature : 99.0</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Blood Pressure',
			vitaltext: '135/85',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
					list: '<li>Blood Pressure : 135/85</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Pulse',
			vitaltext: '90',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
					list: '<li>Pulse : 90</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '24',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
					list: '<li>Respirations : 24</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			scenario: this,
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '97% via nasal cannula',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowVitalsID, {
					list: '<li>02 Sat Level : 97% via nasal cannula</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.hideFooter();
			context.scenario.update508Window(Window508Type.Main);
			context.segment1Part5Debrief();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.ActionCount = this.OldActionCount - 1;
			this.Action1 = true;
		};
		context.getFooterCounts();
	}
}